import axios from 'axios'

export default {
  sendTest(payload) {
    return axios.post(`/marketing/emails/sendTest/${payload.identity}`, payload)
  },

  sendMail(payload) {
    return axios.post(`/marketing/emails/send/${payload.identity}`, payload)
  },
  getMailsHistory(params) {
    return axios.get(`/marketing/emails/list/${params.identity}`, {
      params
    })
  },
  download(payload) {
    return axios.get(`/export/userData/csv?hotspots=${payload.hotspots}`)
  }

}
